var _rect, _rect2, _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeleteLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 28,
    viewBox: "0 0 30 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 29,
    height: 27,
    rx: 3.5,
    fill: "#FAFCFF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 29,
    height: 27,
    rx: 3.5,
    stroke: "#E0E0E0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.8125 9.5C20.8125 9.1895 20.5605 8.9375 20.25 8.9375H9.75C9.4395 8.9375 9.1875 9.1895 9.1875 9.5V19.625C9.1875 20.2715 9.444 20.8918 9.9015 21.3485C10.3583 21.806 10.9785 22.0625 11.625 22.0625H18.375C19.0215 22.0625 19.6418 21.806 20.0985 21.3485C20.556 20.8918 20.8125 20.2715 20.8125 19.625C20.8125 16.25 20.8125 9.5 20.8125 9.5ZM19.6875 10.0625V19.625C19.6875 19.973 19.5495 20.3067 19.3028 20.5527C19.0568 20.7995 18.723 20.9375 18.375 20.9375C16.4685 20.9375 13.5315 20.9375 11.625 20.9375C11.277 20.9375 10.9433 20.7995 10.6973 20.5527C10.4505 20.3067 10.3125 19.973 10.3125 19.625V10.0625H19.6875Z",
    fill: "#3B3B3B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.375 10.0625C18.6855 10.0625 18.9375 9.8105 18.9375 9.5C18.9375 9.5 18.9375 8.75 18.9375 8C18.9375 7.45325 18.72 6.92825 18.3337 6.54125C17.9467 6.155 17.4218 5.9375 16.875 5.9375C15.759 5.9375 14.241 5.9375 13.125 5.9375C12.5783 5.9375 12.0532 6.155 11.6662 6.54125C11.28 6.92825 11.0625 7.45325 11.0625 8V9.5C11.0625 9.8105 11.3145 10.0625 11.625 10.0625H18.375ZM17.8125 8.9375H12.1875V8C12.1875 7.751 12.2865 7.51325 12.462 7.337C12.6383 7.1615 12.876 7.0625 13.125 7.0625H16.875C17.124 7.0625 17.3617 7.1615 17.538 7.337C17.7135 7.51325 17.8125 7.751 17.8125 8V8.9375Z",
    fill: "#3B3B3B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 8.9375H9C8.6895 8.9375 8.4375 9.1895 8.4375 9.5C8.4375 9.8105 8.6895 10.0625 9 10.0625H21C21.3105 10.0625 21.5625 9.8105 21.5625 9.5C21.5625 9.1895 21.3105 8.9375 21 8.9375Z",
    fill: "#3B3B3B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5625 12.875V18.125C12.5625 18.4355 12.8145 18.6875 13.125 18.6875C13.4355 18.6875 13.6875 18.4355 13.6875 18.125V12.875C13.6875 12.5645 13.4355 12.3125 13.125 12.3125C12.8145 12.3125 12.5625 12.5645 12.5625 12.875Z",
    fill: "#3B3B3B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.3125 12.875V18.125C16.3125 18.4355 16.5645 18.6875 16.875 18.6875C17.1855 18.6875 17.4375 18.4355 17.4375 18.125V12.875C17.4375 12.5645 17.1855 12.3125 16.875 12.3125C16.5645 12.3125 16.3125 12.5645 16.3125 12.875Z",
    fill: "#3B3B3B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteLogo);
export default __webpack_public_path__ + "static/media/DeleteLogo.50078f0922a90c1101f4efec12fcf1a6.svg";
export { ForwardRef as ReactComponent };